import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import {ReservationService} from '@app/_components/reservation';

@Component({
    selector: 'app-linen-service',
    templateUrl: './linen-service.component.html',
    providers: [MessageService, ConfirmationService],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class LinenServiceComponent implements OnInit {
  @Input() housekeepingReport: any;
	  constructor(

    private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data: any) {
		// 	this.showFilter = data?.showFilter;
		// this.showPagination = data?.showPagination;
	}
	ngOnInit(): void {

	}


}
